module.exports = __webpack_public_path__ + "img/Venezuela.a5642d9b.svg";